







import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStatics, AcgnTaskMenu, AcgnStaticsStaff } from '@/components';

// 组件申明
@Component({
  components: {
    AcgnStatics,
    AcgnTaskMenu,
    AcgnStaticsStaff
  },
  mixins: [RenderMenuMixin]
})
export default class Statistic extends Vue {

  private manageGroupList: any = [
    {
      id: 1,
      name: '项目待办',
      icon: 'ift-project_2',
      url: 'desk-workerDetail',
      belong: 'worker',
      selected: false,
    }
  ]; // 选中的管理组

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-task-menu authorityCode="3003" source="worker" manageGroupList={this.manageGroupList}></acgn-task-menu>
    );
  }
}
